import Consumer from "../../models/Consumer";
import Terminal from "../../models/Terminal";
import TerminalStrip from "../../models/TerminalStrip";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addConsumerButton from "./guideSequence_addConsumerButton";
import guideSequence_addTerminal from "./guideSequence_addTerminal";

// ContextMenuLables.addFloors
/////////////////////////////////////////////////////////
/////////// noch in bearbeitung hinten angestellt
/////////////////////////////////////////////////
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let firstTerminalStrip: TerminalStrip | undefined = state.allTerminalStrips()[0];
  let firstConsumer: Consumer | undefined = state.allConsumers()[0];
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        let res = new Array<SequenceStep>();
        if (!firstTerminalStrip) {
          res.push(...guideSequence_addTerminal(""));
        }
        if (!firstConsumer) {
          res.push(...guideSequence_addConsumerButton("Consumer")); // no itx
        }
        return res;
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        firstTerminalStrip = state.allTerminalStrips()[0];
        firstConsumer = state.allConsumers()[0];
        state.selectionManager.selectedObject = firstTerminalStrip;
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.focus,
      id: () => {
        return `tv-${firstTerminalStrip?.id}`;
      },
    },
    {
      action: enumActions.click,
      id: () => {
        return [`tv-${firstTerminalStrip?.id}`, `homePane_openTerminalStripSettings`];
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.click,
      id: () => {
        return "terminalStripPropertiesView_connect"; // no itx
      },
    },
  ];
}

export default sequence;
